import { useNavigate } from 'react-router-dom';
import { getDisplayName, getSpreadsRemaining } from '@/api/selectors';
import { useCurrentUser } from '@/context/AuthContext';
import { t } from '@/i18n';
import styles from './ShellTopBar.module.css';

const DEFAULT_AVATAR = String.fromCodePoint(0x1f464);

export function ShellTopBar() {
  const user = useCurrentUser();
  const navigate = useNavigate();
  const spreads = getSpreadsRemaining(user);
  const displayName = getDisplayName(user).replace(/\.$/, '');

  return (
    <header className={styles.bar}>
      <button type="button" className={styles.profile} onClick={() => navigate('/profile')}>
        <span className={styles.avatar} aria-hidden>
          {DEFAULT_AVATAR}
        </span>
        <span className={styles.name}>{displayName}</span>
      </button>

      <button type="button" className={styles.pill} onClick={() => navigate('/profile')}>
        <span className={styles.pillStar} aria-hidden>
          {String.fromCodePoint(0x2726)}
        </span>
        <span className={styles.pillText}>{t.common.spreadsCount(spreads)}</span>
      </button>
    </header>
  );
}
